export { default as HUIProgress } from './hui-progress';
export type { HUIProgressProps } from './types';
